import * as Recharts from 'recharts';

class Bar extends Recharts.Bar {
  static defaultProps = {
    ...Recharts.Bar.defaultProps,
    strokeWidth: 2,
    isAnimationActive: false,
    dataKey: 'value',
  };
}

export default Bar;
